import { render, staticRenderFns } from "./ProductModifiersGroup.vue?vue&type=template&id=d27f60b4&"
import script from "./ProductModifiersGroup.vue?vue&type=script&lang=js&"
export * from "./ProductModifiersGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports